import { useState, useEffect } from 'react'
import { TrendingUp, Users, BarChart3, Calendar, Filter } from 'lucide-react'
import LoadingSpinner from '../ui/LoadingSpinner'
import ErrorMessage from '../ui/ErrorMessage'
import { apiService } from '../../services/api'
import { debug } from '../../utils/debug'

// Sub-components for each tab
import VisitedSalonsSales from './VisitedSalonsSales'
import VisitEffectivenessDetails from './VisitEffectivenessDetails'

const VisitEffectiveness = () => {
  const [activeTab, setActiveTab] = useState('correlation')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  debug.component('VisitEffectiveness', 'Component initialized')

  const tabs = [
    {
      id: 'correlation',
      name: '📊 Korelacja Wizyt-Sprzedaż',
      icon: TrendingUp,
      component: VisitedSalonsSales,
      description: 'Analiza łącznej sprzedaży salonów odwiedzonych przez KAM-ów w zadanym okresie. Wskaźnik pokazuje czy odwiedzane salony generują wysoką sprzedaż.'
    },
    {
      id: 'impact',
      name: '🎯 Wpływ Wizyt na Sprzedaż',
      icon: BarChart3,
      component: VisitEffectivenessDetails,
      description: 'Analiza rzeczywistego wpływu wizyt na zmianę sprzedaży w poszczególnych salonach. Pokazuje które wizyty przynoszą realny wzrost sprzedaży.'
    }
  ]

  const activeTabData = tabs.find(tab => tab.id === activeTab)

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center space-x-3">
        <TrendingUp className="h-6 w-6 text-blue-600" />
        <h2 className="text-2xl font-bold text-gray-900">📈 Efektywność Wizyt KAM</h2>
      </div>

      {/* Tab Navigation */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => {
            const Icon = tab.icon
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  flex items-center space-x-2 py-2 px-1 border-b-2 font-medium text-sm
                  ${activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }
                `}
              >
                <Icon className="h-4 w-4" />
                <span>{tab.name}</span>
              </button>
            )
          })}
        </nav>
      </div>

      {/* Tab Description */}
      {activeTabData && activeTabData.description && (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0">
              <activeTabData.icon className="h-5 w-5 text-blue-600 mt-0.5" />
            </div>
            <div>
              <h4 className="font-medium text-gray-900 mb-1">{activeTabData.name}</h4>
              <p className="text-sm text-gray-600 leading-relaxed">{activeTabData.description}</p>
            </div>
          </div>
        </div>
      )}

      {/* Tab Content */}
      <div className="mt-6">
        {activeTabData && (
          <activeTabData.component />
        )}
      </div>
    </div>
  )
}

export default VisitEffectiveness